import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-addcompany',
  templateUrl: './addcompany.component.html',
  styleUrls: ['./addcompany.component.css']
})
export class AddcompanyComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  taxtypeColl: any = null;
  //Edit Get Values
  companyColl: any = [];
  companyid: number = 0

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  companyform = new FormGroup({
    companyid: new FormControl(0),
    companyname: new FormControl('', Validators.required),
    companyaddress: new FormControl(''),
    taxtype: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Company";


  @Input() companyname: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute, public router: Router,
    private loginService: LoginDataService, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.companyid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.companyform.reset();
      this.fnInitializeCompany();

      if (this.companyid > 0) {
        this.fngetCompany();
      }
      this.fngetTaxType();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.companyid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeCompany() {
    this.companyform.setValue({

      companyid: 0,
      companyname: '',
      companyaddress: '',
      taxtype: '',
      inactive: false,
    })
  }

  fngetTaxType() {
    this.taxtypeColl = [];
    this.taxtypeColl.push({ value: 'GST', displayname: 'GST' })
    this.taxtypeColl.push({ value: 'VAT', displayname: 'VAT' })
    this.taxtypeColl.push({ value: 'NA', displayname: 'N/A' })

  }
  //Get 
  fngetCompany() {

    var data = {
      'companyid': this.companyid,
    }
    this.appService.getCompany(data)
      .subscribe(
        (res) => {
          this.companyColl = res.json().result;
          var editdata = this.companyColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.companyform.valid) {
        // this.saveloading = true
        //Check

        var data = {
          'companyid': this.companyid,
          'companyname': this.companyform.get('companyname').value,
          'companyaddress': this.companyform.get('companyaddress').value,
          'taxtype': this.companyform.get('taxtype').value,
          'inactive': this.companyform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckCompany(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.companyform.get('companyid').value > 0) {
                //Update Department
                this.fnSetCompany(data);
              }
              else {
                //Insert Department
                //this.fnInsertCompany(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false

                this.companyform.controls['companyname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  // fnInsertCompany(data) {

  //   this.appService.fnInsertCompany(data).subscribe(
  //     (res) => {
  //       this.saveloading=false

  //       if (res.json().result != "") {
  //         this.toastr.success('', "The new Company has been added successfully.Insert Successfully");

  //         this.fnInsertActivityLog('INSERT', 0, data.companyid);

  //         this.emitData.emit(this.companyid);
  //         this.activeModal.close(true);
  //       }
  //     },
  //     (err) => {
  //       this.saveloading=false

  //       this.toastr.error('Error', err);
  //     });

  // }

  //Set
  fnSetCompany(data) {

    this.appService.fnSetCompany(data).subscribe(
      (res) => {
        this.saveloading = false

        if (res.json().result != "") {
          this.toastr.success('', "The Company has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.companyid, data.companyname);
          this.fnCloseCompany();
        }
      },
      (err) => {
        this.saveloading = false

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.companyform.setValue({

      companyid: deptBO.companyid,
      companyname: deptBO.companyname,
      companyaddress: deptBO.companyaddress,
      taxtype: deptBO.taxtype,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  //Close
  fnCloseCompany() {
    try {
      this.router.navigate(['/Company']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }







  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
